import React, { useState, useEffect, useCallback } from 'react';
import './ImageCarousel.css';

const SLIDES = [
  { type: 'video', src: '/videohero.mp4' },
  { type: 'image', src: '/piscina-hero1.jpeg' },
  { type: 'image', src: '/piscina-hero2.jpeg' },
  { type: 'image', src: '/piscina-hero3.jpeg' },
  { type: 'image', src: '/piscina-hero4.jpeg' },
];

const ImageCarousel = () => {
  const [currentSlide, setCurrentSlide] = useState(0);
  const [loadedMedia, setLoadedMedia] = useState({});

  const handleMediaLoad = (index) => {
    setLoadedMedia((prev) => ({ ...prev, [index]: true }));
  };

  const nextSlide = useCallback(() => {
    setCurrentSlide((prev) => (prev + 1) % SLIDES.length);
  }, []);

  const prevSlide = () => {
    setCurrentSlide((prev) => (prev - 1 + SLIDES.length) % SLIDES.length);
  };

  // Auto-play: Reinicia o timer sempre que o slide muda manualmente
  useEffect(() => {
    const interval = setInterval(() => {
      nextSlide();
    }, 8000);
    return () => clearInterval(interval);
  }, [nextSlide, currentSlide]);

  return (
    <div className="brilha-carousel">
      <div className="carousel">
        <div className="carousel-main">
          {SLIDES.map((slide, index) => (
            <div 
              key={index} 
              className={`carousel-item ${index === currentSlide ? 'active' : ''}`}
            >
              {/* Overlay de carregamento para o vídeo */}
              {slide.type === 'video' && !loadedMedia[index] && (
                <div className="video-loading-overlay">
                  <div className="spinner"></div>
                </div>
              )}

              {slide.type === 'video' ? (
                <video 
                  src={slide.src}
                  autoPlay
                  muted
                  loop
                  playsInline
                  className={`carousel-media ${loadedMedia[index] ? 'loaded' : ''}`}
                  preload="auto"
                  onLoadedData={() => handleMediaLoad(index)}
                />
              ) : (
                <img 
                  src={slide.src} 
                  alt={`Imagem ${index} da Brilha Piscina`}
                  className={`carousel-media ${loadedMedia[index] ? 'loaded' : ''}`}
                  onLoad={() => handleMediaLoad(index)}
                />
              )}
            </div>
          ))}
        </div>
        
        <button className="nav-arrow prev" onClick={prevSlide} aria-label="Anterior">
          ‹
        </button>
        <button className="nav-arrow next" onClick={nextSlide} aria-label="Próximo">
          ›
        </button>
        
        <div className="carousel-dots">
          {SLIDES.map((_, index) => (
            <button
              key={index}
              className={`dot-btn ${index === currentSlide ? 'active' : ''}`}
              onClick={() => setCurrentSlide(index)}
              aria-label={`Slide ${index + 1}`}
            />
          ))}
        </div>
      </div>
    </div>
  );
};

export default ImageCarousel;
